import { colors } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import palette from '~/theme/palette';

export const useRecordTitleStyles = makeStyles(() => {
  return {
    gridContainer: {
      display: 'flex',
      flexGrow: 1,
    },
    root: {
      display: 'flex',
      width: '100%',
      flexGrow: 1,
    },
    avatar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '10px',
    },
    headline: {
      marginTop: '8px',
    },
    subtitle: {
      lineHeight: '20px',
      paddingBottom: '7px',
      paddingLeft: '1px',
      color: colors.blueGrey[500],
    },
    rightContent: {
      flexGrow: 0,
      flexShrink: 0,
      width: '300px',
      minWidth: '300px',
      alignSelf: 'center',
      marginTop: '-8px',
      /* eslint-disable no-useless-computed-key */
      ['@media (min-width: 1280px)']: {
        width: '360px',
      },
    },
    draftMode: {
      backgroundColor: palette.draft.base,
    },
    editLockMode: {
      backgroundColor: palette.lockEdit.base,
    },
    rightContainer: {
      padding: '8px',
      flexWrap: 'nowrap',
      alignItems: 'center',
    },
    subtitleUuidRow: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    subtitleUuid: {
      marginLeft: '4px',
    },
    subtitleCopyButton: {
      padding: 0,
      marginLeft: '4px',
      color: 'inherit',
    },
    subtitleCopyIcon: {
      fontSize: '0.875rem',
    },
  };
});

export type RecordTitleClasses = ReturnType<typeof useRecordTitleStyles>;
